import React, { useState, useEffect } from "react";
import styles from "./Chat.module.scss";

import { Image } from "@src/components/Image";
import { useDispatch, useSelector } from "react-redux";

import { useRouter } from "@src/lib/router";
import parseToken from "@src/utils/parseToken";
import { getUserToken } from "@src/utils/getAxiosConfig";
import { useTranslation } from "react-i18next";
import { getAwsAssets } from "@src/utils";
import { hitDeeplinkExecutedV2, hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";

import RightAngleIcon from "@src/components/AccentIcons/RightAngleIcon";

const ChatComponent = ({ overviewServerData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewServerData?.course;
  });

  const userDetails = useSelector(
    (state) => state?.overviewReducer?.userDetails
  );
  const handleDescriptionClick = () => {
    let deepLinkObject = {
      screen: "CHAT_DETAILS_CREATE_V2",
      paramOne: `${state?.chatDetails?.id}`, //tutor id 289994
      paramTwo: `${state?.chatDetails?.name}`, //tutor name Gunjan Gupta
      paramThree: "",
      paramFour: "3", //conversation_source
      paramFive: `${router?.query?.courseId}`, //courseId 192
    };
    // alert(JSON.stringify(deepLinkObject));
    hitDeeplinkPerformAction(COMMON_DEEPLINK_ACTIONS.CHAT_DETAILS_CREATE_V2, JSON.stringify(deepLinkObject), JSON.stringify(deepLinkObject), false, true)
    hitDeeplinkExecutedV2(JSON.stringify(deepLinkObject), JSON.stringify(deepLinkObject), true, false)



    // for talk to tutor
    // conversation_source = 3
    // converstion_source_id = ${courseId}
    // console.log(directDeepLink());
    // console.log(
    //   directDeepLink(
    //     deepLinkObject,
    //     "CHAT_DETAILS_CREATE_V2",
    //     true
    //   )(deepLinkObject)
    // );
    // deepLinks;
  };
  useEffect(() => { }, []);
  // console.log(userDetails);
  return (
    <div className={styles.ChatRow} suppressHydrationWarning={true}>
      <div className={styles.ChatRow__Left}>
        <div style={{ position: "relative", width: "48px", height: "38px" }}>
          <Image
            src={getAwsAssets("ChatQuestion.svg", "content")}
            alt="cloud"
            width="48"
            height="38"
            placeholder="blur"
            priority={true}
            loading="eager"
            blurDataURL={getAwsAssets("ChatQuestion.svg", "content")}
          />
        </div>
      </div>
      <div className={styles.ChatRow__Right} suppressHydrationWarning={true}>
        {typeof window !== "undefined" ? (
          <div
            className={styles.ChatRow__Right__Heading}
            suppressHydrationWarning={true}
          >
            {t(
              "components.tabs.overview.components.chat.facingAnyDifficulties",
              "Facing any difficulties,"
            )}{" "}
            {userDetails?.responseData?.user?.name
              ? userDetails?.responseData?.user?.name?.trim()
              : parseToken(getUserToken())?.name?.split(" ")?.[0]?.trim()}
            ?
          </div>
        ) : null}
        <div className={styles.ChatRow__Right__Description}>
          <span
            className={styles.ChatRow__Right__Description__Text}
            onClick={handleDescriptionClick}
          >
            {t(
              "components.tabs.overview.components.chat.talkToMe",
              "Talk to us"
            )}
          </span>
          <div
            style={{
              position: "relative",
              width: "20px",
              height: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2px",
            }}
          >
            <RightAngleIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ChatComponent);
